import moment from 'moment';
import { objectToCamel } from 'ts-case-convert';
import { IExpeditionOptionsQuery, ISuggestionExpedition, ITrip } from '../models';
import { ExpeditionStatus } from '../models/enums';
import { TripsService } from '../services';
import { suggestionExpeditionLabel } from '../utils/suggestionTickets';


const EXPEDITION_OPTION_STATUSES = [
  ExpeditionStatus.OPEN,
  ExpeditionStatus.READY,
  ExpeditionStatus.ONGOING,
  ExpeditionStatus.CLOSED,
];

export async function getExpeditionOptions<Option>(
  tripsService: TripsService,
  query: IExpeditionOptionsQuery,
  toOption: (trip: ITrip) => Option,
): Promise<Option[]> {
  const response: any = await tripsService.getTripsFiltered(
    query.size || 10,
    query.page || 1,
    [],
    [],
    [],
    [],
    EXPEDITION_OPTION_STATUSES,
    query.search,
    query.services,
    query.routes,
    query.dateOnly,
  );
  return (response.content as any[])
    .map((item) => objectToCamel(item) as unknown as ITrip)
    .filter((trip) => !query.excludedIds?.includes(trip.id!))
    .map(toOption);
}

export function suggestionExpeditionOption(expedition: ISuggestionExpedition) {
  return {
    id: expedition.id,
    value: expedition,
    label: suggestionExpeditionLabel(expedition),
  };
}

export function tripSummaryOption(trip: ITrip) {
  return {
    id: trip.id,
    value: trip,
    label: moment(trip.dateTime).format('DD/MM HH:mm'),
    description: `${trip.service.name}`,
  };
}
